import moment from "moment";
import * as _ from "lodash";
import presignedExport from '../../../services/auth/presignedExport';

export default function(angularModule) {
  angularModule.controller(
    'yelpSubscriptionCtrl',
    (
      $scope,
      $http,
      $location,
      $interval
    ) => {

      $scope.status = {
        reloading: false,
        loading: true,
        add: null,
        remove: null
      }

      function toSummary(log) {
        if (!log) {
          return log
        } else {
          const verb = log.type === "Add" ? 'Added' : 'Removed'
          const preposition = log.type === "Add" ? 'to' : 'from'
          const timeSummary = moment(log.timestamp.$date).format("dddd, MMMM Do YYYY, h:mm:ss a")
          if (log.isSuccess) {
            return `${verb} ${log.count} business(es) ${preposition} Yelp subscriptions at ${timeSummary}`
          } else {
            return `Failed to ${log.type.toLowerCase()} ${log.count} business(es) ${preposition} Yelp subscriptions at ${timeSummary}. Error code '${log.errorCode}' and message '${log.errorMessage}'`
          }

        }
      }

      function fetch() {
        $scope.status.reloading = true;
        $http.get('/yelpSubscriptions/status').then(
          resp => {
            $scope.status = {
              loading: false,
              add: toSummary(resp.data.add),
              remove: toSummary(resp.data.remove)
            }
          }
        )
      }

      fetch()
      $scope.refreshStatus = fetch;
      const timer = $interval(fetch, 15000);
      $scope.$on('$destroy', () => {
        $interval.cancel(timer)
      });

      function resetArgs() {
        $scope.args = {
          accountId: undefined,
        }
      }

      const dataParam = $location.search().data;
      if (dataParam) {
        try {
          $scope.args = JSON.parse(dataParam)
        } catch (e) {
          resetArgs()
        }
      } else {
        resetArgs();
      }

      const parseArgs = (args) => {
        return {
          ...args,
          accountId: args.accountId && args.accountId.value,
        }
      }


      $scope.getAccountSelectProps = () => ({
        value: $scope.args.accountId,
        autoload: false,
        loadOptions: (input, cb) => {
          $http.get('/manageTool/accounts', {params: {q: input}})
            .then(resp => {
              let mapped = resp.data.map(x => ({label: `${x.name} (${x.billingAccountName})`, value: x.accountId}));
              cb(mapped)
            })
        },
        onChange: (opt) => {
          $scope.args.accountId = opt;
        }
      });

      $scope.isDownloading = false;

      $scope.exportMonthly = () => {
        $scope.isDownloading = true;
        const args = parseArgs($scope.args);
        presignedExport.downloadExport('/yelpSubscriptions/exportMonthly',args)
          .finally(x => {
            $scope.isDownloading = false;
          })
      }

      $scope.canResync = true;
      $scope.resync = () => {
        if ($scope.canResync) {
          $scope.canResync = false;
          $http.get('/yelpSubscriptions/resync/subscriptions')
        }
      }
      $scope.canResyncMec = true;
      $scope.resyncMec = () => {
        if ($scope.canResyncMec) {
          $scope.canResyncMec = false;
          $http.get('/yelpSubscriptions/resync/mec')
        }
      }

    })
}
